import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdminPanelService} from '../../../data/admin-panel.service';
import {MiscSnackBarService} from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {ProductionPlanningPost} from '../../../../production-planning/data/production-planning-post';
import {
  ProductionPlanningProjectsService
} from '../../../../production-planning/data/production-planning-projects.service';
import {ActivityForEdit} from '../../../data/activityi-for-edit';
import {forkJoin} from 'rxjs';
import {ProductionPlanningWeek} from '../../../../production-planning/data/production-planning-week';
import {ProductionPlanningEvent} from '../../../../production-planning/data/production-planning-event';
import {UsersService} from '../../../../users/data/users.service';
import {User} from 'projects/core/src/lib/login/data/user';

@Component({
  selector: 'app-prod-post-editor-dialog',
  templateUrl: './prod-post-editor-dialog.component.html',
  styleUrls: ['./prod-post-editor-dialog.component.scss']
})
export class ProdPostEditorDialogComponent implements OnInit {
  saveLoading = false;
  tempPost: ProductionPlanningPost
  tempWeek: ProductionPlanningWeek

  tempStartTime: Date
  tempEndTime: Date;

  activitiesForEdit: ActivityForEdit[]

  loadingSpinner = true;
  users: User[] = [];

  constructor(
    protected dialogRef: MatDialogRef<ProdPostEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    protected productionPlanningProjectsService: ProductionPlanningProjectsService,
    private usersService: UsersService,
    @Inject(MAT_DIALOG_DATA) private data: {
      post: ProductionPlanningPost,
      postWeek: ProductionPlanningWeek,
    }
  ) {
    this.tempPost = Object.assign({}, this.data.post)
    this.tempWeek = Object.assign({}, this.data.postWeek)
    if (this.tempWeek.startDate) {
      const endDate = new Date(this.tempWeek.startDate)
      endDate.setDate(endDate.getDate() + 4)
      const startDateFormatted = this.tempWeek.startDate.toLocaleDateString('en-US', {month: 'short', day: 'numeric'})
      const endDateFormatted = this.tempWeek.startDate.getMonth() === endDate.getMonth() ? endDate.toLocaleDateString('en-US', {day: 'numeric'}) : endDate.toLocaleDateString('en-US', {month: 'short', day: 'numeric'})
      this.tempWeek.period = startDateFormatted + ' - ' + endDateFormatted
    }
  }

  ngOnInit(): void {
    this.productionPlanningProjectsService.getActivityTypeByPostId(this.tempPost.id).subscribe(activitiesForEdit => {
      this.activitiesForEdit = activitiesForEdit;

      const rolesString = Array.from(this.tempPost.roles).join(',');
      if (rolesString) {
        this.usersService.getUsersByRoles(0, 1000, rolesString, true).subscribe(userResponse => {
          this.users = userResponse.content || [];
          this.loadingSpinner = false;
        }, error => {
          this.loadingSpinner = false;
          this.miscSnackBarService.openErrorSnackBar('Something went wrong loading users');
        });
      } else {
        this.usersService.getActiveUsers().subscribe(users => {
          this.users = users;
          this.loadingSpinner = false;
        }, error => {
          this.loadingSpinner = false;
          this.miscSnackBarService.openErrorSnackBar('Something went wrong loading users');
        });
      }
    }, error => {
      this.loadingSpinner = false;
      this.miscSnackBarService.openErrorSnackBar('Something went wrong')
    })
  }

  saveDict() {
    this.saveLoading = true;

    const serviceArr = [this.adminPanelService.saveProductionPost(this.tempPost)]
    if (this.tempWeek?.id) {
      serviceArr.push(this.adminPanelService.saveProductionWeek(this.tempWeek))
    }

    this.activitiesForEdit.forEach(activity => {
      serviceArr.push(this.adminPanelService.saveActivityCondition(activity))
    })

    forkJoin(serviceArr).subscribe(res => {
      this.miscSnackBarService.openSuccessSnackBar('Success!')

      this.dialogRef.close(res[0]);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.saveLoading = false;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }
}
